import z from "zod";

/**
 * PesquisaSatisfacaoClienteSchema
 */

export const PesquisaSatisfacaoClienteSchema = z.object({
  respondidaPor: z.string().nullable().default(null),
  data: z.coerce.date().nullable().default(null),
  local: z.string().nullable().default(null),
  status: z.coerce.number().default(0),
  observacao: z.string().nullable().default(null),
  itens: z.array(z.object({
    idItemPesquisaCliente: z.number(),
    descricao: z.string().nullable().default(null),
    nota: z.number().nullable().default(null),
  })),
});

/**
 * PesquisaSatisfacaoClienteForm
 */

export type PesquisaSatisfacaoClienteForm = z.infer<typeof PesquisaSatisfacaoClienteSchema>;